import { render } from "./AssignUsersModal.vue?vue&type=template&id=f0e5f5f4&scoped=true"
import script from "./AssignUsersModal.vue?vue&type=script&lang=js"
export * from "./AssignUsersModal.vue?vue&type=script&lang=js"

import "./AssignUsersModal.vue?vue&type=style&index=0&id=f0e5f5f4&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e5f5f4"]])

export default __exports__